import { associationTypesList } from '@/portal-api.definition';
import z from 'zod';

const associationTypeEnum = z.enum(associationTypesList);

export const holderInputStateSchema = z.object({
  associationType: associationTypeEnum,
});
export type HolderInputState = z.infer<typeof holderInputStateSchema>;

export const contactSelectionStateSchema = z.object({
  associationType: associationTypeEnum,
  selectedContact: z.string(),
  contactSelectionContacts: z.array(
    z.object({
      Contact: z.string(),
      Type: associationTypeEnum,
      Id: z.number(),
    }),
  ),
});
export type ContactSelectionState = z.infer<typeof contactSelectionStateSchema>;

export const codeInputStateSchema = z.object({
  associationType: associationTypeEnum,
  selectedContact: z.string(),
  contactId: z.number().optional(),
  contactSelectionContacts: z
    .array(
      z.object({
        Contact: z.string(),
        Type: associationTypeEnum,
        Id: z.number(),
      }),
    )
    .optional(),
});
export type CodeInputState = z.infer<typeof codeInputStateSchema>;

export const successStateSchema = z.object({
  services: z.object({
    Type: z.string(),
    DefaultAccountId: z.string(),
    Holder: z.object({
      PrimaryUserDisplayName: z.string(),
      HouseHoldName: z.string(),
      PictureUri: z.string(),
      ServiceAccounts: z.array(z.any()),
      UsernameAliases: z.array(z.any()),
    }),
  }),
});
export type SuccessState = z.infer<typeof successStateSchema>;
